<template>
  <v-container fluid class="pa-0 ma-3">
    <v-btn
      class="ma-2"
      @click="exportToExcel"
      append-icon="mdi-file-excel"
      variant="outlined"
      >Excel</v-btn
    >
    <v-btn
      class="ma-2"
      @click="print"
      append-icon="mdi-printer"
      variant="outlined"
      >print</v-btn
    >

    <v-container>
      <v-form>
        <v-date-input
          variant="outlined"
          rounded
          label="من"
          v-model="date1"
        ></v-date-input>
        <v-date-input
          variant="outlined"
          rounded
          label="إلى"
          v-model="date2"
        ></v-date-input>
      </v-form>

      <v-autocomplete
        class="mx-auto"
        width="50%"
        v-model="meter_id"
        label="العداد"
        :items="filteredMeters"
        item-title="name"
        item-text=""
        item-value="id"
        placeholder="Search by meter"
        prepend-inner-icon="mdi-magnify"
        menu-icon=""
        rounded
        theme="light"
        variant="solo"
        auto-select-first
        item-props
      ></v-autocomplete>
    </v-container>
    <v-container>
      <v-div id="printArea" dir="rtl">
        <v-data-table
          v-model="selected"
          :items="metersActions"
          :headers="headers"
        >
          <template v-slot:[`item.amount`]="{ item }">
            <v-container>
              <p>{{ item.last_reading - item.last_paid }}</p>
            </v-container>
          </template></v-data-table
        >
      </v-div>
    </v-container>
  </v-container>
  <overlay-loader v-model="loading" />
</template>

<script>
import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";
import { VDateInput } from "vuetify/labs/VDateInput";

import * as XLSX from "xlsx";

export default {
  components: {
    VDateInput,
    OverlayLoader,
  },
  data: () => ({
    date1: null,
    date2: null,
    meter_id: -1,
    headers: [
      { title: "تاريخ العملية", key: "actionDate" },
      { title: "الرصيد الحالي", key: "current_balance" },
      { title: "القراءة السابقة", key: "last_paid" },
      { title: "آخر قراءة", key: "last_reading" },
      { title: "كمية الاستهلاك", key: "amount" },
      { title: "قيمة الاستهلاك", key: "value" },
      { title: "الخصم الكلي", key: "totalDiscount" },
    ],
    loading: false,
    dialog: false,
  }),
  computed: {
    actions() {
      return repo.actions.getAllActions();
    },
    meters() {
      return repo.meters.getAllMeters();
    },
    metersActions() {
      if (this.meter_id == -1) {
        return [];
      }
      let uu = this.actions.filter(
        (x) => x.meter_id == this.meter_id && x.actionType == "prompt"
      );

      if (this.date1 != null) {
        const filterDate = new Date(this.date1);

        uu = uu.filter((x) => new Date(x.actionDate) >= filterDate);
      }

      if (this.date2 != null) {
        const filterDate = new Date(this.date2);

        uu = uu.filter((x) => new Date(x.actionDate) <= filterDate);
      }

      return uu;
    },
    filteredMeters() {
      return this.meters;
    },
    dataToExport() {
      const res = this.metersActions.map(
        ({
          actionDate,
          current_balance,
          last_paid,
          last_reading,
          amount,
          value,
          totalDiscount,
        }) => ({
          actionDate: actionDate,
          current_balance: current_balance,
          last_paid: last_paid,
          last_reading: last_reading,
          amount: amount,
          value: value,
          totalDiscount: totalDiscount,
        })
      );
      return res;
    },
  },
  methods: {
    exportToExcel() {
      // Create a worksheet from the data
      const worksheet = XLSX.utils.json_to_sheet(this.dataToExport);

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Export the workbook to a file
      XLSX.writeFile(workbook, "data.xlsx");
    },
    print() {
      const printElement = document.getElementById("printArea");
      if (!printElement) {
        console.error("Element not found");
        return;
      }

      const printContent = printElement.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");

      printWindow.document.write(`
    <html>
        <head>
            <title>Print Content</title>
            <style>
                @media print {
                    body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0;
                        height: 100vh;  /* Ensure the body takes full height */
                        padding: 20px;
                        box-sizing: border-box; /* Include padding in width calculations */
                    }
                    @page {
                        margin: 0;
                    }
                }
            </style>
        </head>
        <body dir=rtl>
            ${printContent}
        </body>
    </html>
`);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },

    async fetch() {
      this.loading = true;
      const res = await repo.actions.fetchAll();
      const res2 = await repo.meters.fetchAll();
      if (res && res2) {
        //swalFun.success("success");
        console.log(res2);
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
